module.exports = __webpack_public_path__ + "static/media/bg_main_1.4c8bbda2.png";